import React, { useEffect, useState, useRef } from 'react';
import { PRIORITY_OPTIONS, getPriorityBadgeStatus } from '@nile/components';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { Badge, Dropdown as Select } from '@superops/ui-design-system';

function InlinePriorityCell(props) {
  const { _task, cell, params, editCellId } = props;
  const task = _task || cell?.row?.original;
  const allProps = params || cell.column;
  const { actions, editable, shouldFreezeCell, setEditCell } = allProps;
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);
  const isEditable = !isCellFreezed && editable;

  const [selectedOption, setSelectedOption] = useState(
    task?.priority
      ? PRIORITY_OPTIONS.find((p) => p.value === task.priority.toLowerCase())
      : null
  );

  useEffect(() => {
    setSelectedOption(
      task?.priority
        ? PRIORITY_OPTIONS.find((p) => p.value === task.priority.toLowerCase())
        : null
    );
  }, [task?.priority]);

  return (
    <div className="fx fw actr">
      <div className={`flex center g5 fw full-height `}>
        {selectedOption ? (
          <Badge status={getPriorityBadgeStatus(selectedOption.value)}>
            {selectedOption.label}
          </Badge>
        ) : (
          <div className="ellipsis self-center fg1 flex center full-height rounded-4px font-weight-600">
            NA
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(InlinePriorityCell);
